document.addEventListener("DOMContentLoaded", () => {
    let hasScrolled = false;

    // Select the scroller element and listen for scroll events
    const scroller = document.querySelector('.scroller');
    if (scroller) {
        scroller.addEventListener('scroll', () => {
            hasScrolled = true;
        });
    }

    document.querySelectorAll(".button").forEach(el => {
        el.addEventListener('click', function(e) {
            // If the scroller has been scrolled, do not add the loading class
            if (hasScrolled) {
                e.preventDefault();
                hasScrolled = false; // Reset the flag
                return; // Stop the function execution
            }

            // Add the loading class and loader node
            this.classList.add("loading");
            const loaderNode = document.createElement("span");
            loaderNode.classList.add('loader');
            this.appendChild(loaderNode);

            // Function to remove the loading class
            const removeLoadingClass = () => {
                this.classList.remove("loading");
                loaderNode.remove();
                window.removeEventListener('scroll', removeLoadingClass);
            }
            window.addEventListener('scroll', removeLoadingClass);
        });
    });
});